import { IDieuChinhRequest } from "../../model/request/hoa-don-dien-tu/IDieuChinhRequest";
import { IHoaDonDienTuPagingRequest } from "../../model/request/hoa-don-dien-tu/IHoaDonDienTuPagingRequest";
import { IPhatHanhDichVuMultipleRequest } from "../../model/request/hoa-don-dien-tu/IPhatHanhDichVuMultipleRequest";
import { IHoaDonTheoKyHieuRequest } from "../../model/request/hoa-don-dien-tu/IHoaDonTheoKyHieuRequest";
import { IPhatHanhRequest } from "../../model/request/hoa-don-dien-tu/IPhatHanhRequest";
import { IProcessRequest } from "../../model/request/IProcessRequest";
import {
  IRaSoatHoaDonRequest,
  IRaSoatHoaDonRow,
} from "../../model/respone/hoa-don-dien-tu/IRaSoatHoaDon";
import {
  IHoaDonDieuChinhThuCongHuyRequest,
  IHoaDonDieuChinhThuCongSaveRequest,
  IHoaDonDieuChinhThuCongSelectRequest,
} from "../../model/respone/hoa-don-dien-tu/IHoaDonDieuChinhThuCong";
import { apiClient } from "../apiClient";

export const HOA_DON_DIEN_TU_ENDPOINT = "hoa-don";

export const hoaDonDienTuApi = {
  SelectPaging: (request: IHoaDonDienTuPagingRequest) =>
    apiClient.post(
      `${HOA_DON_DIEN_TU_ENDPOINT}/select-hoadondientu-paging`,
      request
    ),
  PhatHanh: (request: IPhatHanhRequest) =>
    apiClient.post(`${HOA_DON_DIEN_TU_ENDPOINT}/phat-hanh`, request),
  PhatHanhMultiple: (request: IProcessRequest<IPhatHanhRequest[]>) =>
    apiClient.post(
      `${HOA_DON_DIEN_TU_ENDPOINT}/phat-hanh-multiple?process_id=${request.process_id}`,
      request.payload
    ),
  DieuChinh: (request: IDieuChinhRequest) =>
    apiClient.post(`${HOA_DON_DIEN_TU_ENDPOINT}/dieu-chinh`, request),
  Huy: (id_bien_lai: number) =>
    apiClient.get(`${HOA_DON_DIEN_TU_ENDPOINT}/huy/${id_bien_lai}`),
  Preview: (payload: IPhatHanhRequest) =>
    apiClient.post(`${HOA_DON_DIEN_TU_ENDPOINT}/preview`, payload),
  XemChiTiet: (request: IPhatHanhRequest) =>
    apiClient.post(`${HOA_DON_DIEN_TU_ENDPOINT}/xem-chi-tiet`, request),
  // ky_hieu: lấy đúng hóa đơn của ký hiệu đó; bỏ trống = hóa đơn mới nhất của biên lai.
  ExportPDF: (id_bien_lai: number, ky_hieu?: string) =>
    apiClient.get(
      `${HOA_DON_DIEN_TU_ENDPOINT}/export-pdf/${id_bien_lai}` +
        (ky_hieu ? `?ky_hieu=${encodeURIComponent(ky_hieu)}` : "")
    ),
  PhatHanhNhap: (request: IPhatHanhRequest) =>
    apiClient.post(`${HOA_DON_DIEN_TU_ENDPOINT}/phat-hanh-nhap`, request),
  DongBoTrangThai: (request: IProcessRequest<IHoaDonDienTuPagingRequest>) =>
    apiClient.post(
      `${HOA_DON_DIEN_TU_ENDPOINT}/dong-bo-trang-thai?process_id=${request.process_id}`,
      request.payload
    ),
  PhatHanhDichVuMultiple: (request: IPhatHanhDichVuMultipleRequest) =>
    apiClient.post(
      `${HOA_DON_DIEN_TU_ENDPOINT}/phat-hanh-dich-vu-multiple`,
      request
    ),
  DongBoDichVuMultiple: (request: IPhatHanhDichVuMultipleRequest) =>
    apiClient.post(
      `${HOA_DON_DIEN_TU_ENDPOINT}/dong-bo-dich-vu-multiple`,
      request
    ),
  ExportExcelChonXuat: (id_bien_lais: number[]) =>
    apiClient.post(
      `${HOA_DON_DIEN_TU_ENDPOINT}/export-excel-chon-xuat`,
      id_bien_lais
    ),
  ExportExcelList: (request: IHoaDonDienTuPagingRequest) =>
    apiClient.post(`${HOA_DON_DIEN_TU_ENDPOINT}/export-excel`, request),
  // Đồng bộ số hóa đơn VNPT cho hóa đơn đã phát hành nhưng chưa có số (lấy qua API theo fkey).
  DongBoSoHoaDonVNPT: () =>
    apiClient.post(`${HOA_DON_DIEN_TU_ENDPOINT}/dong-bo-so-hoa-don-vnpt`, {}),
  // Backfill HĐ dịch vụ MISA cũ (bản ghi mầm): kéo số HĐ + tiền từ MISA vào để báo cáo đếm được.
  BackfillDichVuMisa: () =>
    apiClient.post(`${HOA_DON_DIEN_TU_ENDPOINT}/backfill-dich-vu-misa`, {}),
  // Menu Quản trị — quét hóa đơn bên nhà phát hành (CHỈ ĐỌC) để hiện modal xem trước...
  RaSoatHoaDonVNPT: (request: IRaSoatHoaDonRequest) =>
    apiClient.post(`${HOA_DON_DIEN_TU_ENDPOINT}/quan-tri/vnpt/ra-soat`, request),
  RaSoatHoaDonMInvoice: (request: IRaSoatHoaDonRequest) =>
    apiClient.post(
      `${HOA_DON_DIEN_TU_ENDPOINT}/quan-tri/minvoice/ra-soat`,
      request
    ),
  RaSoatHoaDonMisa: (request: IRaSoatHoaDonRequest) =>
    apiClient.post(`${HOA_DON_DIEN_TU_ENDPOINT}/quan-tri/misa/ra-soat`, request),
  // ...rồi GHI đúng những dòng người dùng đã tích trong modal.
  CapNhatHoaDonVNPT: (rows: IRaSoatHoaDonRow[]) =>
    apiClient.post(`${HOA_DON_DIEN_TU_ENDPOINT}/quan-tri/vnpt/cap-nhat`, {
      rows,
    }),
  CapNhatHoaDonMInvoice: (rows: IRaSoatHoaDonRow[]) =>
    apiClient.post(`${HOA_DON_DIEN_TU_ENDPOINT}/quan-tri/minvoice/cap-nhat`, {
      rows,
    }),
  CapNhatHoaDonMisa: (rows: IRaSoatHoaDonRow[]) =>
    apiClient.post(`${HOA_DON_DIEN_TU_ENDPOINT}/quan-tri/misa/cap-nhat`, {
      rows,
    }),
  // Danh sách hóa đơn TÁCH THEO KÝ HIỆU (1 biên lai có thể ra nhiều HĐ) + gộp HĐ dịch vụ.
  // ===== Điều chỉnh số tiền hóa đơn nhập tay =====
  SelectDieuChinhThuCong: (request: IHoaDonDieuChinhThuCongSelectRequest) =>
    apiClient.post(`${HOA_DON_DIEN_TU_ENDPOINT}/dieu-chinh-thu-cong/lich-su`, request),
  InsertDieuChinhThuCong: (request: IHoaDonDieuChinhThuCongSaveRequest) =>
    apiClient.post(`${HOA_DON_DIEN_TU_ENDPOINT}/dieu-chinh-thu-cong`, request),
  HuyDieuChinhThuCong: (request: IHoaDonDieuChinhThuCongHuyRequest) =>
    apiClient.post(`${HOA_DON_DIEN_TU_ENDPOINT}/dieu-chinh-thu-cong/huy`, request),
  SelectTheoKyHieu: (request: IHoaDonTheoKyHieuRequest) =>
    apiClient.post(`${HOA_DON_DIEN_TU_ENDPOINT}/theo-ky-hieu`, request),
  // Đồng bộ trạng thái các HĐ "phát hành nháp" trong bộ lọc (kéo số HĐ + tiền từ nhà phát hành).
  DongBoTrangThaiTheoKyHieu: (request: IHoaDonTheoKyHieuRequest) =>
    apiClient.post(
      `${HOA_DON_DIEN_TU_ENDPOINT}/theo-ky-hieu/dong-bo-trang-thai`,
      request
    ),
  // Xuất Excel danh sách hóa đơn tách theo ký hiệu (đúng bộ lọc đang xem).
  ExportExcelTheoKyHieu: (request: IHoaDonTheoKyHieuRequest) =>
    apiClient.post(
      `${HOA_DON_DIEN_TU_ENDPOINT}/theo-ky-hieu/export-excel`,
      request
    ),
  // Breakdown ký hiệu theo danh sách biên lai (màn Hóa đơn điện tử chính):
  // mỗi biên lai còn ký hiệu nào chưa xuất + ký hiệu nào đã xuất kèm số HĐ.
  SelectKyHieuByBienLais: (id_bien_lais: number[], id_config_invoice = 0) =>
    apiClient.post(`${HOA_DON_DIEN_TU_ENDPOINT}/ky-hieu-by-bien-lais`, {
      id_bien_lais,
      id_config_invoice,
    }),
};
